import { FC, useRef } from 'react';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from 'framework/Icon';
import { Tooltip } from 'framework/Tooltip';

import { GRID_LINE_HEIGHT } from '../../../constants';
import { useGridContext } from '../context/GridContext';

import { GridHeader } from './GridHeader';
import { GridLabelHeaderProps } from './types';

import cn from '../Grid.module.scss';

export const GridHeaderLabel: FC<GridLabelHeaderProps> = ({ column, index, style }) => {
  const { header_clamp } = useGridContext();
  const ref = useRef<HTMLDivElement | null>(null);

  const { text_align, information, label } = column.props;
  const inline_style = {
    textAlign: text_align,
    lineClamp: header_clamp,
    WebkitLineClamp: header_clamp,
    lineHeight: `${GRID_LINE_HEIGHT}em`,
    maxHeight: `${GRID_LINE_HEIGHT * header_clamp}em`,
    alignItems: 'center',
  };
  return (
    <GridHeader column={column} index={index} style={style}>
      <GridHeader.Sort column={column}>
        <p className={cn.label} style={inline_style}>
          {label}
        </p>
        {information && (
          <Tooltip information={information}>
            <Icon ref={ref} icon={faInfoCircle} />
          </Tooltip>
        )}
      </GridHeader.Sort>
    </GridHeader>
  );
};
